// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1Nvyv","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__OCeBj"};